module.exports = __webpack_public_path__ + "static/media/1010264.5bb6a9c8.jpg";